import { render, staticRenderFns } from "./AllPublications.vue?vue&type=template&id=8fcb7c20&"
import script from "./AllPublications.vue?vue&type=script&lang=js&"
export * from "./AllPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports